//  ----------      START   IMPORT  BLOCK       ----------
//  Services
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import { type CreateDiagnosisParams } from '../../Types/schema-helpers';
//  ----------      END   IMPORT  BLOCK       ----------

class DiagnosisService extends APIService {
  /**
   * Creates a new diagnosis entry.
   * @param payload Exact JSON body expected by the backend API.
   */
  async createDiagnosisEntry(payload: CreateDiagnosisParams): Promise<any> {
    const route = API_ROUTES.create_diagnosis_entry;
    return this.post(route, payload);
  }

  /**
   * Fetches the patient's full history by username.
   * @param username The patient's username query.
   */
  async fetchDiagnoses(username: string): Promise<any> {
    const route = API_ROUTES.get_patient_history(username);
    return this.get(route);
  }
}

export default new DiagnosisService();